/**
 * ISO-2 language → flag emoji + label.
 * Used in CRM/prospect UI to display the prospect's preferred language.
 */

const LANG_INFO = {
  fr: { flag: "🇫🇷", label: "Français" },
  en: { flag: "🇬🇧", label: "English" },
  es: { flag: "🇪🇸", label: "Español" },
  it: { flag: "🇮🇹", label: "Italiano" },
  de: { flag: "🇩🇪", label: "Deutsch" },
  pt: { flag: "🇵🇹", label: "Português" },
};

export const LANG_OPTIONS = Object.entries(LANG_INFO).map(([code, info]) => ({
  code,
  ...info,
}));

export function langFlag(code) {
  return (LANG_INFO[code] || LANG_INFO.fr).flag;
}

export function langLabel(code) {
  return (LANG_INFO[code] || LANG_INFO.fr).label;
}

export function LangBadge({ code, className = "" }) {
  const info = LANG_INFO[code] || LANG_INFO.fr;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-neutral-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-neutral-700 ${className}`}
      title={info.label}
      data-testid={`lang-badge-${code || "fr"}`}
    >
      <span className="text-sm leading-none">{info.flag}</span>
      <span>{code || "fr"}</span>
    </span>
  );
}
